<template>
  <div class="item" v-if="item" @click="goDetail(item)">
    <div class="item-img" :style="{ backgroundImage: 'url(' + item.cover_img + ')' }">
      <img :src="item.cover_img" alt="" @error="imgError(item)">
      <div class="defaultRedBtnBox flex" v-if="labelName">
        <div class="defaultRed-btn">
          <div class="btn item-tips ellipsis">{{ labelName }}</div>
        </div>
      </div>
    </div>
    <div class="item-txt">
      <div class="item-name ellipsis" :title="item.name">{{ item.name }}</div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'brandItem',
  props: {
    item:Object,
    labelName: {
      type: String,
      default() {
        return "专题"
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
    goDetail(info) {
      try {
        if (this.$route.meta.detailPage) {
          this.$router.push({
            path: "/thematic/" + info.id,
          })
        }
        let link = this.$router.resolve({
          path: "/thematic/" + info.id,
        })
        window.open(link.href, '_blank')
      } catch (err) {
        this.$router.push({
          path: "/thematic/" + info.id,
        })
      }

    }
  }
}
</script>
<style scoped >
.item {
  position: relative;
}

.item .item-img {
  background: center center no-repeat;
  background-size: cover;
}

.item .item-img img {
  opacity: 0;
  width: 100%;
  height: auto;
}</style>